import { withErrorHandling } from "@entrilia/shared/api/axiosHelper";
import { logError } from "@entrilia/shared/logging";
import { sanitizeEmail } from "@entrilia/shared/utilities/emailHelper";
import adminApi from "../../../../../api/adminApi";
import type { ContactEmailOwnership } from "../../../../../api/types/fundStructureTypes";

const getContactEmailAvailability = withErrorHandling(adminApi.getContactEmailAvailability);

export const emailAvailabilityUnknownText =
  "We couldn’t check whether that address is already in use. Please try again in a moment.";

export const checkContactEmailAvailability = async (
  contactId: string,
  email: string,
  logContext: string
): Promise<ContactEmailOwnership> => {
  const [resp, error] = await getContactEmailAvailability(contactId, sanitizeEmail(email));
  if (error) {
    logError(error, `${logContext} getContactEmailAvailability`);
    return "Unknown";
  }

  return resp.ownership;
};
